import { render, staticRenderFns } from "./BoxDialog.vue?vue&type=template&id=632ffe12&scoped=true"
import script from "./BoxDialog.vue?vue&type=script&lang=js"
export * from "./BoxDialog.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=632ffe12&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ffe12",
  null
  
)

export default component.exports